import CheckBoxField from '../components/fields/CheckBoxField'
import TwoFactorField from '../components/fields/TwoFactorField'

const fields = (locale = { twoFactorLabel: '', trustDevice: '' }) => ({
  twoFactorCode: {
    name: 'twoFactorCode',
    showEye: true,
    component: TwoFactorField,
    label: locale.twoFactorLabel || 'Two-factor authentication code',
    inputProps: {
      autoComplete: 'off',
    },
    fullWidth: true,
    hasPopover: false,
    required: true,
  },
  trustDevice: {
    name: 'trustDevice',
    component: CheckBoxField,
    label: locale.trustDevice || 'Trust this device',
    required: false,
  },
})

export default fields
